
// Affichage du menu
$('label.menu-toggle').on('click', function () {
	$('div.menu-drop').removeClass('menu-closed');
});

// Ferme le menu et réduit sa taille pour éviter qu'il soit par dessus la page en mode mobile
$('label.close-menu').on('click', function () {
	setTimeout(function () {
		$('div.menu-drop').addClass('menu-closed');
	}, 400);
});
